import './App.css';
import React, { useEffect, useState, useRef } from 'react';
import HeaderComponent from './components/HeaderComponent';
import FooterComponent from './components/FooterComponent';
import { LanguageProvider } from './components/LanguageContext';  // import the provider
import {ForeGroundContext} from './components/ForeGroundContext';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import HomeComponent from './components/HomeComponent';

function App() {


  const [isMenuVisible, setIsMenuVisible] = useState(true); // Controls menu visibility
  const [prevMenuScrollPos, setPrevMenuScrollPos] = useState(0); // Tracks the last scroll position
  const [isForeGround, setIsForeGround] = useState(false);
  const [isScrollEnabled, setIsScrollEnabled] = useState(true);

  {/**scroll detection */}
    // Use a ref to store the previous scroll position
  const prevMenuScrollPosRef = useRef(0);
  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;

    if (!isScrollEnabled) {
      return;
    }

    if (currentScrollPos > 70) {
    if (currentScrollPos > prevMenuScrollPosRef.current) {
        // Scrolling down, hide menu
        setIsMenuVisible(false);
    } else {
        // Scrolling up, show menu
        setIsMenuVisible(true);
    }
  } else {
    // If user scrolls back to top area (< 70px), always show the menu
    setIsMenuVisible(true);
  }
    // Update the previous scroll position
    prevMenuScrollPosRef.current = currentScrollPos;
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
        window.removeEventListener("scroll", handleScroll); // Cleanup
    };
    }, [isScrollEnabled]);
    
  return (
    <LanguageProvider>
    <div>
      <ForeGroundContext.Provider value={{isForeGround, setIsForeGround}}>
        <HeaderComponent isMenuVisible={isMenuVisible} isScrollEnabled={isScrollEnabled} setIsScrollEnabled={setIsScrollEnabled} />
        <HomeComponent isMenuVisible={isMenuVisible} />
        {/*<BrowserRouter>
          <Routes>
            <Route path='/drop' element={DropDownComponent}></Route>
          </Routes>
        </BrowserRouter>*/}
        <FooterComponent />
      </ForeGroundContext.Provider>
    </div>
    </LanguageProvider>
  );
}

export default App;